import { render } from "./BaseField.vue?vue&type=template&id=5d3e5453"
import script from "./BaseField.vue?vue&type=script&lang=js"
export * from "./BaseField.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__